import axios from 'axios';
import _ from 'lodash';

const api = axios.create();

export const updateDefaults = (axiosInstance, properties = {}) => {
  const instance = axiosInstance;
  // invariant
  _.merge(instance.defaults, properties);
  return instance;
};

const getPurchaseButton = (params = {}) =>
  api
    .get('services/payway/purchasebuttoninfo', { params })
    .then(({ data }) => data);

const getWorkflowStart = endpoint => api.get(endpoint).then(({ data }) => data);

const getSearchVertical = (params = {}) =>
  api.get('services/search/vertical', { params }).then(({ data }) => data);

export default api;

export { getPurchaseButton, getWorkflowStart, getSearchVertical };
